import { useTagById, useTagTasks } from 'features/tags';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';
import { ID } from 'shared/types/id';
import { TypeSections } from 'shared/types/page-sections';
import { SortingMode } from 'shared/types/sorting-mode';
import { TaskType } from 'shared/types/task-base';
import { getSortedTasks } from 'shared/utils/get-sorted-tasks';
import { getWeekStartsOn } from 'shared/utils/get-week-starts-on';

export const useTagTypeTaskSections = (id?: ID) => {
  const today = useToday();
  const user = useUser();
  const tag = useTagById(id);
  const tasks = useTagTasks(id);
  const weekStartsOn = getWeekStartsOn(user);

  const sections = useMemo(
    () => [
      {
        id: TypeSections.Tasks,
        items: getSortedTasks(
          tasks.filter(({ type }) => type !== TaskType.Habit),
          {
            today,
            weekStartsOn,
            mode: Array.from(
              new Set([SortingMode.DueDate, tag?.taskSortingMode]),
            ).filter(Boolean) as SortingMode[],
            order: tag?.taskSorting ?? [],
          },
        ),
      },
      {
        id: TypeSections.Habits,
        items: getSortedTasks(
          tasks.filter(({ type }) => type === TaskType.Habit),
          {
            today,
            weekStartsOn,
            mode: Array.from(
              new Set([SortingMode.DueDate, tag?.taskSortingMode]),
            ).filter(Boolean) as SortingMode[],
            order: tag?.taskSorting ?? [],
          },
        ),
      },
    ],
    [tag, tasks, today, weekStartsOn],
  );

  return {
    sections,
    tasks,
  };
};
